import { Box } from "@chakra-ui/layout";

interface IRangeSliderThumbLegendProps {
  text: string;
  align?: "center" | "left";
}

function RangeSliderThumbLegend({
  text,
  align = "center",
}: IRangeSliderThumbLegendProps) {
  return (
    <Box
      fontWeight="medium"
      position="absolute"
      top="20px"
      textAlign={align}
      left={align === "center" ? "-47.5px" : 0}
      minW={"95px"}
    >
      {text}
    </Box>
  );
}

export default RangeSliderThumbLegend;
